var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoWrap"},[(_vm.showAli)?_c('div',{staticClass:"prism-player",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"J_prismPlaye"}}):_vm._e(),(_vm.showTianyi)?_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"autoplay":"","controls":"","controlslist":"nodownload","src":_vm.filegzeduVideoUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }